import styled, { css } from 'styled-components'

export const AssetLoadingState = styled.div`
    padding: 50px;
    font-size: 18px;
    color: ${({ theme }) => theme.gray};
`

export const LoadingContainer = styled(AssetLoadingState)`
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    height: 100%;
    font-size: 22px;
`
export const Separator = styled.div`
    height: 20px;
    width: 20px;
`
